import { api } from '@/service/http';

export const aiTreeNodeLoadStore = async args => {
    const apiResp = await api(args.api, args);
    apiResp.api = args.api;
    return apiResp;
};

const localStoreData = {};
export const aiTreeNodeLoadStoreLocalGet = api => {
    if (!localStoreData) {
        return undefined;
    } else {
        if (!localStoreData[api]) {
            return undefined;
        }
        return localStoreData[api];
    }
};
export const aiTreeNodeLoadStoreLocalSet = (api, dataSet, findResultData) => {
    localStoreData[api] = { dataSet, findResultData };
};

export const aiTreeNodeLoadStoreLocalSetProp = (api, prop, data) => {
    if (!localStoreData[api]) {
        localStoreData[api] = {};
    }
    localStoreData[api][prop] = data;
};
